module.exports = __webpack_public_path__ + "img/subscribe-photo.fcfb5b23.png";